<script lang="ts">
  import { onMount } from "svelte";
  import { track } from "../helpers/mixpanel";

  let popup,
    showPopup = false;

  const table_rows = [
    {
      amount: "£164.34",
      icon: "static/assets/icons/mobile/arrow-left.svg",
      status: "credit note <br>applied",
      time_offset: 0,
    },
    {
      amount: "£48.10",
      icon: "static/assets/icons/mobile/check.svg",
      status: "paid",
      time_offset: 1,
    },
    {
      amount: "£23.34",
      icon: "static/assets/icons/mobile/details.svg",
      status: "pending",
      time_offset: 2,
    },
    {
      amount: "£163.10",
      icon: "static/assets/icons/mobile/check.svg",
      status: "paid",
      time_offset: 2,
    },
    {
      amount: "£564.34",
      icon: "static/assets/icons/mobile/arrow-right.svg",
      status: "refunded",
      time_offset: 2,
    },
    {
      amount: "£948.10",
      icon: "static/assets/icons/mobile/check.svg",
      status: "paid",
      time_offset: 3,
    },
    {
      amount: "£164.34",
      icon: "static/assets/icons/mobile/arrow-left.svg",
      status: "credit note <br>applied",
      time_offset: 4,
    },
    {
      amount: "£48.10",
      icon: "static/assets/icons/mobile/check.svg",
      status: "paid",
      time_offset: 5,
    },
    {
      amount: "£23.34",
      icon: "static/assets/icons/mobile/details.svg",
      status: "pending",
      time_offset: 5,
    },
    {
      amount: "£163.10",
      icon: "static/assets/icons/mobile/check.svg",
      status: "paid",
      time_offset: 6,
    },
    {
      amount: "£564.34",
      icon: "static/assets/icons/mobile/arrow-right.svg",
      status: "refunded",
      time_offset: 7,
    },
    {
      amount: "£948.10",
      icon: "static/assets/icons/mobile/check.svg",
      status: "paid",
      time_offset: 7,
    },
  ];

  const table_rows_with_date = table_rows.map((row, index) => {
    const date = new Date();
    date.setDate(date.getDate() - row.time_offset);
    return {
      ...row,
      date: date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
      }),
    };
  });

  const today = new Date().toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });

  const week_ago = new Date();
  week_ago.setDate(week_ago.getDate() - 7);
  const a_week_ago = week_ago.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });

  onMount(() => {
    track("insights_mobile_landing_open", {});
    setTimeout(() => {
      showPopup = true;
    }, 100);
  });
</script>

<div class="container">
  <h1>REKKI INSIGHTS</h1>
  <div class="content">
    <div class="time-interval">
      <label>Time interval</label>
      <p>{a_week_ago} - {today}</p>
    </div>
    <div class="buttons">
      <button>SPEND REPORT</button>
      <button>PRICE HISTORY</button>
    </div>
    <table>
      <thead>
        <tr>
          <th class="amount">amount due</th>
          <th class="status">status</th>
          <th>due date</th>
        </tr>
      </thead>
      <tbody>
        {#each table_rows_with_date as row}
          <tr>
            <td class="amount"><div class="blur">{row.amount}</div></td>
            <td class="status">
              <div class="blur">
                <div class="icon-box">
                  <img src={row.icon} alt="" />
                  {@html row.status}
                </div>
              </div>
            </td>
            <td><div class="blur">{row.date}</div></td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
  <div class="popup" class:showPopup bind:this={popup}>
    <h2>Insights just got even better – but you’ll need a laptop 💻</h2>
    <p>access Insights on a desktop to:</p>
    <ul>
      <li>see a real time overview of your spend and COGS</li>
      <li>get price change alerts</li>
      <li>calculate your GP with ease</li>
    </ul>
  </div>
  <div class="popup-background" />
</div>

<style>
  @keyframes popup {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
    }
  }
  .container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    overflow: hidden;
    font-family: "REKKI-Regular", sans-serif;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 0 18px;
  }

  h1 {
    padding: 15px;
    font-size: 34px;
    line-height: 1;
    letter-spacing: -2px;
    color: #000000b2;
    font-weight: normal;
    font-family: "REKKI-Medium", sans-serif;
  }

  .popup {
    position: fixed;
    bottom: 0;
    right: 0;
    border-radius: 20px;
    background-color: #000;
    margin: 9px;
    padding: 20px 20px 30px 20px;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 4px;
    transform: translateY(150%);
    /* animation: popup 0.3s 1s ease-out forwards; */
    max-width: min(calc(100% - 18px), 396px);
    width: 100%;
    will-change: transform;
    transition: transform 0.2s cubic-bezier(0, 0, 0.01, 1);
    box-sizing: border-box;
    z-index: 2;
  }

  .popup-background {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: #00000033;
    z-index: 1;
    opacity: 0;
    transition: opacity 1s;
  }

  .popup.showPopup {
    will-change: transform;
    transform: translateY(0%);
  }

  .popup.showPopup + .popup-background {
    opacity: 1;
  }

  .popup h2 {
    margin: 0 0 4px;
    padding: 0;
    font-size: 30px;
    line-height: 37px;
    letter-spacing: -0.7px;
    font-weight: normal;
  }

  .popup p {
    font-size: 19px;
    line-height: 26px;
    letter-spacing: -0.2px;
    color: #fff9;
    padding: 0;
    margin: 0;
  }

  .popup ul {
    font-size: 19px;
    line-height: 26px;
    letter-spacing: -0.2px;
    padding: 0;
    margin: 0;
    list-style: none;
    padding-left: 28px;
  }

  .popup li {
    position: relative;
    color: #fff9;
  }
  .popup li::before {
    content: "•";
    padding: 0 10px;
    position: absolute;
    top: 0;
    right: 100%;
  }

  .time-interval {
    opacity: 0.8;
    background-color: #e8e8e8;
    border-radius: 8px;
    display: flex;
    color: #0008;
    flex-direction: column;
    gap: 4px;
    padding: 13px 14px 10px;
    font-size: 28px;
    line-height: 32px;
    letter-spacing: -1px;
  }

  .time-interval label {
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.2px;
    font-family: "REKKI-OCD";
    text-transform: uppercase;
    opacity: 0.8;
  }

  .time-interval p {
    opacity: 0.8;
    padding: 0;
    margin: 0;
  }

  .buttons {
    display: flex;
    gap: 8px;
  }

  .buttons button {
    flex: 1;
    border: none;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 20.47px;
    line-height: 23px;
    letter-spacing: 0.26px;
    font-family: "REKKI-OCD", sans-serif;
    opacity: 0.8;
    color: #0006;
    background-color: #e8e8e8;
    white-space: nowrap;
    pointer-events: none;
  }

  table {
    border-collapse: collapse;
    overflow: hidden;
    border-radius: 13.21px;
  }
  table thead th {
    background-color: #e8e8e8;
    font-size: 12.75px;
    line-height: 18.1px;
    letter-spacing: 0.21px;
    color: #0006;
    font-family: "REKKI-OCD", sans-serif;
    font-weight: normal;
    text-transform: uppercase;
    padding: 16px 0;
    width: 33%;
  }

  table thead th.status {
    text-align: left;
    width: 43%;
  }

  table thead th.amount {
    text-align: left;
    padding-left: 16px;
  }

  table tbody td {
    padding: 17px 0;
    vertical-align: middle;
    text-align: center;
  }
  table tbody td.status {
    text-align: left;
  }
  table tbody td.amount {
    text-align: left;
    padding-left: 16px;
  }

  .icon-box {
    display: flex;
    gap: 8.5px;
    font-size: 14.88px;
    line-height: 17px;
    letter-spacing: 0.21px;
    color: #0009;
    align-items: center;
    font-family: "REKKI-OCD", sans-serif;
    white-space: nowrap;
    text-transform: uppercase;
  }

  table tbody td {
    border-bottom: 1px solid #0001;
    font-size: 17px;
    line-height: 19px;
    letter-spacing: -0.32px;
    color: #575757;
  }

  table tbody tr:nth-child(even) td {
    background-color: #f8f8f8;
  }

  .blur {
    filter: blur(2px);
  }
</style>
